import { Component, inject, computed } from '@angular/core';
import { UIStore, AuthStore } from '@easihub/ngx';
import { AnonymousHeaderComponent } from './anonymous/anonymous-header.component';

@Component({
  selector: 'header#app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  host: {
    '[class.h-16]': 'visible()',
    '[class.border-b]': 'visible()'
  },
  imports: [
    AnonymousHeaderComponent
  ]
})
export class HeaderComponent {
  private readonly ui = inject(UIStore);
  private readonly auth = inject(AuthStore);

  protected readonly visible = computed(() => this.ui.layout() !== 'minimal');

  protected readonly user = computed(() => this.auth.user());
}
